export const GET_INPC = 'GET_INPC';
export const SET_INPC_FILTERS = 'SET_INPC_FILTERS';
export const SET_INPC_PAGINATION = 'SET_INPC_PAGINATION';
export const RESET_INPC_LIST = 'RESET_INPC_LIST';
export const RESET_INPC_FORM = 'RESET_INPC_FORM';
export const GET_INPC_BY_ID = 'GET_INPC_BY_ID';
export const MODIFY_EDITING_INPC = 'MODIFY_EDITING_INPC';
export const ADD_INPC = 'ADD_INPC';
export const UPDATE_INPC = 'UPDATE_INPC';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/constants/inpc_constants.js